import { Shield, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Privacy() {
  const sections = [
    {
      title: '1. Information We Collect',
      content: [
        'We collect no information. Local Route is designed with privacy as a core principle.',
        'No personal information is collected',
        'No usage analytics or tracking',
        'No cookies or fingerprinting',
        'No network requests to external servers',
        'No account registration required'
      ]
    },
    {
      title: '2. Data Storage',
      content: [
        'All extension data is stored locally using Chrome\'s built-in storage API:',
        'Shortcuts: URLs, names, and categories you create',
        'Settings: Your preferences and configurations',
        'Profiles: Custom profile names and associated shortcuts',
        'This data never leaves your browser. We cannot access it, and it is not transmitted anywhere.'
      ]
    },
    {
      title: '3. Permissions',
      content: [
        'Local Route requests minimal permissions required for functionality:',
        'Storage: To save your shortcuts and settings locally',
        'Tabs: To open URLs in new tabs when you launch shortcuts',
        'Commands: To enable keyboard shortcuts for quick access',
        'We do not request access to your browsing history, bookmarks, or any other sensitive browser data.'
      ]
    },
    {
      title: '4. Third-Party Services',
      content: [
        'Local Route does not integrate with any third-party services, analytics platforms, or advertising networks.',
        'Your data stays on your device.'
      ]
    },
    {
      title: '5. Data Export and Deletion',
      content: [
        'You have full control over your data:',
        'Export: Use the built-in export feature to download all your shortcuts as a JSON file',
        'Delete: Remove individual shortcuts, profiles, or all data from within the extension',
        'Uninstall: Removing the extension automatically deletes all associated data'
      ]
    },
    {
      title: '6. Children\'s Privacy',
      content: [
        'Local Route does not collect any personal information from anyone, including children under 13.',
        'Since no data is collected or transmitted, there are no special considerations needed for children\'s privacy.'
      ]
    },
    {
      title: '7. Changes to This Policy',
      content: [
        'If we ever change this privacy policy, we will update the "Last updated" date at the top of this page.',
        'Given our commitment to not collecting data, significant changes are unlikely.'
      ]
    },
    {
      title: '8. Contact',
      content: [
        'If you have questions about this privacy policy, you can reach out through the Chrome Web Store listing or contact us at: contact@cemates.me'
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      <div className="pt-32 pb-20">
        <div className="max-w-2xl mx-auto px-6">
          {/* Back link */}
          <Link
            to="/portfolio/local-route"
            className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors mb-8"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Local Route
          </Link>

          {/* Header */}
          <div className="mb-16">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-muted mb-6">
              <Shield className="w-5 h-5 text-foreground" />
            </div>
            <h1 className="text-3xl font-semibold text-foreground mb-3">
              Privacy Policy
            </h1>
            <p className="text-muted-foreground text-sm">
              Local Route • Last updated: January 1, 2026
            </p>
          </div>

          {/* TL;DR highlight */}
          <div className="mb-12 p-6 rounded-xl bg-muted/50 border border-border">
            <p className="text-muted-foreground text-sm leading-relaxed">
              <span className="font-medium text-foreground">TL;DR:</span> Local Route stores all data locally on your device. 
              We don't collect, transmit, or have access to any of your personal information or browsing data.
            </p>
          </div>

          {/* Sections */}
          <div className="space-y-12">
            {sections.map((section, index) => (
              <div key={index}>
                <h2 className="text-lg font-medium text-foreground mb-4">
                  {section.title}
                </h2>
                <ul className="space-y-3">
                  {section.content.map((item, itemIndex) => (
                    <li key={itemIndex} className="text-muted-foreground text-sm leading-relaxed flex gap-3">
                      <span className="text-muted-foreground/50 select-none">•</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
